import axios from "axios";

export default axios.create({
 // baseURL: "https://emxhjhptq3.ap-northeast-1.awsapprunner.com/",
  //baseURL: "https://saveOrUpdateCustomerServiceRequest.html/",
  // baseURL: "https://repairadda.com:8443/neobetest/interactionhistory/9853258963",
   baseURL: "https://api.repairadda.com/",
  responseType: "json",
});
